<style src="./Modal.scss" lang="scss"></style>

<template lang="pug">
  .modal
    .modal__overlay(
      @click='close'
    )
    .modal__scroll
      .modal__box
        button.modal__close(
          @click='close'
        )
          Icon(
            name='close'
          )
        slot
</template>

<script>
import { mapActions } from "vuex";
import Icon from "@/components/Icon/Icon";

export default {
  props: {
    name: String
  },
  components: { Icon },
  methods: {
    ...mapActions({
      close: "modal/close"
    })
  }
};
</script>
